import { useRef } from "react";
import AttendanceList from "./attendance-list";

const AttendanceMain = (props) => {
  const listRef = useRef(null);

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <AttendanceList ref={listRef} />
    </div>
  );
};

export default AttendanceMain;
